// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[type=file][data-v-07c54495]{position:absolute;left:-99999px}", ""]);
// Exports
module.exports = exports;
